<template>
  <div style="margin-bottom: 170px">
    <!-- Tab -->
    <BuTab></BuTab>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="pa-5 d-flex">
        <div class="form-input-group w-702px mr-5">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <button class="btn btn-primary w-88px" @click="getBuyChannels">搜尋</button>
      </div>

      <!-- table -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <div v-if="lengthOfisCheckedList > 0"
               class="form-item d-flex align-center px-5 h-60px batch">
            <h5 class="col-checkbox">
              <v-checkbox
                v-model="checkAllStatus"
                :indeterminate="indeterminate"
                @click="changeAllCheckbox"
              ></v-checkbox>
            </h5>
            <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
            <div>
              <button class="btn btn-danger mr-10px" @click="multiDelete">
                <v-icon color="white" class="mr-2">delete</v-icon>
                <span>刪除</span>
              </button>
            </div>
            <!--<div>-->
              <!--<button class="btn mr-10px" @click="changePublish(true)">設為顯示</button>-->
            <!--</div>-->
            <!--<div>-->
              <!--<button class="btn" @click="changePublish(false)">設為隱藏</button>-->
            <!--</div>-->
          </div>
          <tr>
            <th>
              <v-checkbox
                v-model="checkAllStatus"
                :indeterminate="indeterminate"
                @click="changeAllCheckbox"
              ></v-checkbox>
            </th>
            <th class="text-left">Logo</th>
            <th class="text-left">公司名稱</th>
            <th class="text-left">通路形式</th>
            <th class="text-left">通路國家</th>
            <th class="text-left">BU</th>
            <th class="text-left">Order</th>
            <th class="text-left">編輯</th>
            <th class="text-left">刪除</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in buyChannels"
            :key="item.id"
          >
            <td>
              <v-checkbox v-model="item.isChecked"></v-checkbox>
            </td>
            <td>
              <div
                class="w-40px h-40px bg-cover bg-center"
                :style="{
                  'background-image': `url(${item.logo})`,
                }"
              ></div>
            </td>
            <td>{{ item.title }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.country.name }}</td>
            <td>{{ item.bu.name }}</td>
            <td>{{ item.order }}</td>
            <td>
              <button class="btn square" @click="toWhereToBuyEdit(item.id)">
                <v-icon>edit</v-icon>
              </button>
            </td>
            <td>
              <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!-- table footer -->
      <Pagination @handleNextPreEvent="getBuyChannels" model="buyChannel"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BuTab from '@/components/BuTab.vue';
import Pagination from '@/components/Pagination.vue';
// import FormSwitch from '@/components/FormSwitch.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    deleteDialog,
    BuTab,
    Pagination,
    // FormSwitch,
  },
  data: () => ({
    checkAllStatus: false, // left top checkbox status
  }),
  computed: {
    ...mapState(['currentBuTabId']),
    ...mapState('buyChannel', ['buyChannels', 'filter']),
    lengthOfisCheckedList() {
      return this.buyChannels.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.buyChannels.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.buyChannels.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.buyChannels.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.buyChannels.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.buyChannels.length) {
        this.checkAllStatus = true;
      }
    },
    currentBuTabId(newValue) {
      this.filter.buId = newValue;
      this.getBuyChannels();
    },
  },
  methods: {
    ...mapActions('buyChannel', {
      getBuyChannels: 'find',
      destroyBuyChannel: 'destroy',
    }),
    toWhereToBuyEdit(id) {
      this.$router.push({
        name: 'WhereToBuyEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.buyChannels.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.buyChannels.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      await this.destroyBuyChannel(id).then(() => {
        this.getBuyChannels();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyBuyChannel(id).then(() => {});
      });
      this.getBuyChannels();
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-logo {
    width: 40px;
    margin-right: 20px;
  }
  .col-company-name {
    min-width: 100px;
    margin-right: 45px;
  }
  .col-pathway {
    width: 80px;
    margin-right: 18px;
  }
  .col-bu {
    min-width: 126px;
    margin-right: 10px;
  }
  .col-order {
    width: 80px;
    margin-right: 10px;
    text-align: right;
  }

  .col-show {
    margin-right: 40px;
  }
}
</style>
